/*
 * @Author: your name
 * @Date: 2020-12-05 14:02:42
 * @LastEditTime: 2021-04-07 09:28:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Input\ScreenInput.js
 */

import * as THREE from 'three'
import { InputBase } from './InputBase'
import { CameraController } from '../CameraController'
import { CameraPoint, CPointSet } from '../CameraPoints'
import { config } from '../config'

export class ScreenInput extends InputBase {
  constructor (cps) {
    super()
    /**
     * @type {THREE.Intersection[]} 射线相交的结果，数组形式
     */
    this.intersectRls = []
    /**
     * @type {THREE.Raycaster} 屏幕发出的射线
     */
    this.raycaster = new THREE.Raycaster()

    this.tapPosition = new THREE.Vector3(0, 0, 0)

    /**
     * @type {CPointSet} cpset
     */
    this.cps = cps
  }

  /**
   * 更新射线检测
   */
  updateRaycast () {
    this.raycaster.setFromCamera(this.mouseCoords, this.cam.camera)
  }

  /**
   * 合适的、最近的移动到的点位置
   * @param {THREE.Vector3} point 鼠标射线与模型交汇的点位坐标
   * @param {THREE.Vector3} cameraPosition 摄像机位置
   * @returns {CameraPoint} 点位
   */
  findTargetCPoint (point, cameraPosition) {
    // 遍历所有相机点，找出离光标最近的点位，更新全局cameraLocation的值
    // 1.首先判断点的准不准，圈非常小，变色半径1700，这里1500吧
    // 2.如果很不准 则在相机位置半径5000内，找出最符合方向的那个点。

    if (this.controller.camera.cameraMode) {
      const rls = ScreenInput.findNearestNeighbour(this.controller.camera.cameraCurrentIndex, point, this.cps)
      if (rls.dist < config.Interact.MaxDistSqr && rls.cpoint.id !== this.controller.camera.cameraCurrentIndex) {
        return rls.cpoint
      } else { // 指的不太行
        const dir = this.cam.target.clone()
          .sub(this.cam.camera.position)
        const drls = InputBase.findInNeighbour(this.controller.camera.cameraCurrentIndex, cameraPosition, dir, this.cps)
        return drls.cpoint
      }
    } else {
      const rls = ScreenInput.findNearest(point, this.cps)
      return rls.cpoint
    }
  }

  /**
   * 传入鼠标射线坐标，计算最近的位置
   *
   * @param {THREE.Vector3} point 鼠标射线与模型交汇的点位坐标
   * @param {CPointSet} cps 点位集合
   * @returns {{dist:number, cpoint:CameraPoint}} 与目标点位最小距离，目标点位
   */
  static findNearest (point, cps) {
    let minD = Number.MAX_VALUE
    let minCp = null
    for (const cp of cps.CameraPoints) {
      const distSq = point.distanceToSquared(cp.pointMesh.position) // 光标与该点位的距离
      if (distSq < minD) {
        minD = distSq
        minCp = cp
      }
    }
    return { dist: minD, cpoint: minCp }
  }

  /**
   * 传入鼠标射线坐标，计算最近且可以看见的点位位置
   *
   * @param {number} camCurrIdx 当前下标
   * @param {THREE.Vector3} point 鼠标射线与模型交汇的点位坐标
   * @param {CPointSet} cps 点位集合
   * @returns {{dist:number, cpoint:CameraPoint}} 与目标点位最小距离，目标点位
   */
  static findNearestNeighbour (camCurrIdx, point, cps) {
    const neighbour = cps.findVisiable(camCurrIdx)
    let minD = Number.MAX_VALUE
    let minCp = null
    for (const cpid of neighbour) {
      const cp = cps.getCameraPoint(cpid)
      const distSq = point.distanceToSquared(cp.pointMesh.position) // 光标与该点位的距离
      if (distSq < minD) {
        minD = distSq
        minCp = cp
      }
    }
    return { dist: minD, cpoint: minCp }
  }

  moveTo () {
    const target = this.findTargetCPoint(this.tapPosition, this.cam.camera.position)
    if (!target) return
    this.cam.cameraDestinationIndex = target.id
    if (this.cam.cameraMode) {
      if (this.cam.cameraCurrentIndex !== this.cam.cameraDestinationIndex) {
        this.controller.animateCamera(this.cam.camera.position, this.cam.cameraDestinationIndex)
      }
    } else {
      this.controller.toPano(target.id)
    }
  }
}
